// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__e-LJJ","topBottomGutter":"Layout_topBottomGutter__1ZzD0"};